import styled from 'styled-components'

export const Container = styled.section`
  float: left;
  width: 100%;
  margin-bottom: 40px;
  padding: 0 30px 30px 30px;
  background: #000;

  display: flex;
  align-items: initial;
  justify-content: center;

  @media only screen and (max-width: 900px) {
    display: inline-block;
    padding: 0 15px 0 15px;
    margin: 0 0 15px 0px;
  }
`
